import {
  Alert,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from "@mui/material";
import { PushNotificationContext } from "context/PushNotificationContext";
import { Main } from "pages/_layouts/Main";
import React, { FC, useContext } from "react";
import { useAppDispatch, useAppSelector } from "store";
import { setDevTools } from "store/modules/layout";
import { NotificationTest } from "./components/NotificationTest";
import { useDialog } from "hooks/useDialog";
import { DialogSendNotification } from "./components/DialogSendNotification";

export const DevMode: FC = () => {
  const { devMode, devTools } = useAppSelector((state) => state.layout);

  if (!devMode) {
    return <Alert severity="error">O Modo Desenvolvedor esta desligado</Alert>;
  }

  const {
    isSupported,
    permission,
    token,
    requestPermission,
    requestPushToken,
    lastNotification,
  } = useContext(PushNotificationContext);

  const {
    RenderDialog: DialogNotificacoes,
    hide: hideDialogNotificacoes,
    show: showDialogNotificacoes,
  } = useDialog({
    title: "Enviar notificação de teste",
  });

  const dispatch = useAppDispatch();

  return (
    <Main title="Modo Desenvolvedor">
      <DialogNotificacoes>
        <DialogSendNotification hide={hideDialogNotificacoes} token={token} />
      </DialogNotificacoes>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card>
            <CardHeader title="Testes Push Notification" />
            {!isSupported && (
              <CardContent>
                <Typography>
                  Se você não esta vendo nada aqui é porque seu dispositivo não
                  tem suporte a Push Notification
                </Typography>
              </CardContent>
            )}
            {isSupported && (
              <NotificationTest
                isSupported={isSupported}
                permission={permission}
                requestPermission={requestPermission}
                requestPushToken={requestPushToken}
                token={token}
                lastNotification={lastNotification}
                showDialogNotificacoes={showDialogNotificacoes}
              />
            )}
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardHeader title="Ferramentas"></CardHeader>
            <CardContent>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={devTools?.thumbnailBase64 || false}
                      onChange={({ target: { checked } }) =>
                        dispatch(setDevTools({ thumbnailBase64: checked }))
                      }
                    />
                  }
                  label="Criar cache do avatar no formato Base64"
                />
              </FormGroup>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Main>
  );
};
